
<mat-tab-group class="flex-fill">
    <mat-tab label="Cases">
        <banner-component></banner-component>
        <dashboard-filter-bar
            [accountOptions]="accountOptions"
            [dateRanges]="dateRanges"
            [showStatus]="true"
            [statusOptions]="statusOptions"
            [activeFilterCount]="activeFilterCount"
            (filtersChange)="onFiltersChange($event)"
            (cleared)="onFiltersCleared()">
        </dashboard-filter-bar>
        <app-dashboard-sla-due-date-filters
            #casesSlaFilters
            [slaDueDateCounts]="slaDueDateCounts"
            [totalItems]="caseDataSource?.data?.length || 0"
            [isDisabled]="!atLeastOneQueueHasSLA"
            [selectedIds]="slaFilters"
            (valueEmitted)="handleslaFiltersEmitted($event)"
        ></app-dashboard-sla-due-date-filters>
        <div class="mrs-table-container">
            <div class="filterPane">
                <app-queue-filter-carousel
                    [filters]="filters"
                    [allCasesId]="myCasesQueueId"
                    [selectedCount]="getSelectedFiltersCount()"
                    [isSideNavHidden]="isSideNavHidden"
                    (valueEmitted)="onQueueFilterEmitted($event)"
                ></app-queue-filter-carousel>
            </div>
            <div class="mrs-table-inner-container" style="background-color: white; padding: 16px; margin-top: 30px; gap: 8px;">
                <div class="d-flex align-items-center" style="gap: 8px;">
                    <h2 style="margin: 0;">My Cases</h2>
                    <mat-chip *ngIf="activeFilterCount > 0" disabled class="filter-count-badge">{{ activeFilterCount }} Filter{{ activeFilterCount === 1 ? '' : 's' }} Active</mat-chip>
                </div>
                <div style="max-height: 46vh; overflow-y: scroll;">
                    <table
                        #dataTable
                        mat-table
                        matSort
                        class="mat-elevation-z1"
                        style="overflow-y: auto;"
                        [dataSource]="caseDataSource"
                    >
                        <!-- Dynamic Columns -->
                        @for (col of dynamicColumns; track col.id)
                        {
                            <ng-container [matColumnDef]="col.columnDefinition">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width:200px;">
                                    {{ col.displayName }}
                                </th>
                                <td mat-cell *matCellDef="let row"> {{ row[col.mapKeyName] }} </td>
                            </ng-container>
                        }
                        <!-- Note -->
                        <ng-container matColumnDef="note">
                            <th mat-header-cell *matHeaderCellDef style="min-width: 150px; max-width:175px;" id="noteHeader">
                                {{notesColumns[0]?.displayName}}
                            </th>
                            <td
                                style="min-width: 150px; max-width: 175px; white-space: break-spaces;"
                                mat-cell *matCellDef="let element"
                                [innerHTML]="element.latestNoteContent | removeHTMLTags"
                            >
                            </td>
                        </ng-container>
                        <!-- Actions -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td
                                mat-cell
                                class="ms-2 align-content-center"
                                *matCellDef="let element"
                                (click)="stopPropagation($event)"
                                class="cell-icon"
                            >
                            @if (element.usersInCase && element.usersInCase != null)
                            {
                                <em
                                    aria-hidden="true"
                                    class="ms-1 fa fa-asterisk"
                                    style="color: red; margin-right: 10px;"
                                    [matTooltip]="element.usersInCase"
                                >
                                </em>
                            }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: columnsToDisplay;"
                            (click)="viewCaseDetails(row)"
                            style="cursor: pointer;"
                        >
                        </tr>
                        <!-- No Data Row -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="columnsToDisplay.length">
                                <div class="p-4 text-center text-muted ">
                                    <img src="./assets/images/no-data-placeholder.png " alt=" " class="pb-3 " />
                                    <h6>No Cases Found</h6>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            @if (caseDataSource?.data?.length > 0)
            {
            <div class="flex mat-paginator-sticky mat-mdc-paginator-container">
                <mat-paginator
                    #paginator
                    [length]="caseDataSource?.data?.length || 0"
                    [pageIndex]="0"
                    [pageSize]="10"
                    appearance="fill"
                    [pageSizeOptions]="[10, 25, 50, 100]"
                >
                </mat-paginator>
            </div>
            }
        </div>
    </mat-tab>
    <mat-tab label="Tasks">
        <dashboard-tasks-component [clientId]="clientId" [tasks]="tasks"></dashboard-tasks-component>
    </mat-tab>
</mat-tab-group>
